import { SectionNames } from 'builder/modules/resumeEditor'

export const KEYWORDS_ANALYTICS_LABEL: Partial<Record<SectionNames, string>> = {
  profile: 'profile',
  workExperiences: 'work_experience',
}
